import {
  SUBSCRIBE_WEBSOCKET_TOPIC,
  UNSUBSCRIBE_WEBSOCKET_TOPIC,
  WEBSOCKET_SET_STATUS
} from '../actions/websocket';
import { mapRemove, mapSet } from '../../components/helpers/immutable';

const webSocket = (state, action) => {
  switch (action.type) {
    case WEBSOCKET_SET_STATUS:
      return {
        ...state,
        wsStatus: action.payload
      };
    case SUBSCRIBE_WEBSOCKET_TOPIC:
      return {
        ...state,
        wsSubscriptions: mapSet(state.wsSubscriptions, action.topic, action.sid)
      };
    case UNSUBSCRIBE_WEBSOCKET_TOPIC:
      return {
        ...state,
        wsSubscriptions: mapRemove(state.wsSubscriptions, action.topic)
      };
    default:
      return state;
  }
};
export default webSocket;
